import * as angular from 'angular';

//(function () {
//    'use strict';

//    angular
//        .module('app')
//        .config(SetEmailForm);

//    /** @ngInject */
//    function SetEmailForm($stateProvider) {
//        $stateProvider
//            .state('set_email', {
//                url: '/ustawienie-adresu-email',
//                template: '<im-set-email></im-set-email>'
//            });
//    }

//})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/set_email/set_email.route.ts